module.exports = __webpack_public_path__ + "img/somac.19b246a3.jpg";